import { Injectable, Injector } from "@angular/core";
import { HttpEvent, HttpInterceptor, HttpHandler, HttpRequest, HttpResponse } from "@angular/common/http";
import { Observable, pipe } from "rxjs";
import { timer } from "rxjs";
import { tap } from "rxjs/operators";
import { LoaderService } from "./loader.service";

@Injectable({
    providedIn: "root"
})
export class LoaderInterceptorService implements HttpInterceptor {
    public pendingRequests: number = 0;
    public showLoading: boolean = false;
    public startedLoading: number = 0;

    constructor(private loaderService: LoaderService) { }

    intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        this.pendingRequests++;
        this.showLoader();
        return next.handle(req).pipe(tap((event: HttpEvent<any>) => {
            if (event instanceof HttpResponse) {
                const resp: HttpResponse<any> = event;
                let body: {} = resp.body;
                this._prepareDates(body);

                var t = timer(1000);
                t.subscribe(t => {
                    this.onEnd();
                });
            }
        },
            (err: any) => {
                this.onEnd();
            }));
    }

    private onEnd(): void {
        this.hideLoader();
    }

    private showLoader(): void {
        if (!this.loaderService.ifDisabled()) {
            if (!this.showLoading) {
                this.showLoading = true;
                this.startedLoading = new Date().getTime();
            }
            this.loaderService.show();
        }
    }

    private hideLoader(): void {
        this.pendingRequests--;
        var showingTime = new Date().getTime() - this.startedLoading;
        if (showingTime >= 30000) {
            this.pendingRequests = 0;
        }
        if (this.pendingRequests <= 0) {
            this.showLoading = false;
            this.startedLoading = 0;
            this.loaderService.hide();
        }
    }

    private _prepareDates(obj: any): void {
        for (let key in obj) {
            if (obj.hasOwnProperty(key)) {
                let element = obj[key];
                if (typeof element === "object") {
                    this._prepareDates(element);
                } else if (typeof element === "string") {
                    const matched = /\d{4}\-\d{2}\-\d{2}T\d{2}\:\d{2}\:\d{2}\.\d{3}/.exec(element);
                    if (matched) {
                        const localDate = new Date(element);
                        obj[key] = localDate;
                    }
                }
            }
        }
    }
}